import { render } from "./sys-admin.vue?vue&type=template&id=5c3d8f80&scoped=true"
import script from "./sys-admin.vue?vue&type=script&lang=js"
export * from "./sys-admin.vue?vue&type=script&lang=js"

import "./sys-admin.vue?vue&type=style&index=0&id=5c3d8f80&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3d8f80"]])

export default __exports__